import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { useRevealOnScroll } from '../../hooks/useRevealOnScroll'

// Amostra curada FICTÍCIA do banco, apenas para apresentação na landing
// (evita queries Supabase no caminho público e garante qualidade/variação
// editorial). O banco real é acessado após o cadastro.
interface PreviewQuestion {
  serie: string
  topico: string
  dificuldade: 'Fácil' | 'Médio' | 'Difícil'
  tipo: 'Múltipla escolha' | 'Dissertativa' | 'V/F'
  enunciado: string
}

const PREVIEW_BANK: { disciplina: string; questions: PreviewQuestion[] }[] = [
  {
    disciplina: 'Matemática',
    questions: [
      { serie: '6º ano', topico: 'Frações', dificuldade: 'Fácil', tipo: 'Múltipla escolha', enunciado: 'Dona Marta dividiu uma pizza em 8 fatias iguais e serviu 5 aos netos. Que fração da pizza sobrou para o jantar?' },
      { serie: '7º ano', topico: 'Problemas com frações', dificuldade: 'Médio', tipo: 'Múltipla escolha', enunciado: 'Seu Joaquim vende mangas a R$ 3 cada. Pela manhã vendeu 2/5 das 60 mangas da banca e, à tarde, 1/3 do total. Quantas mangas restaram?' },
      { serie: '8º ano', topico: 'Geometria plana', dificuldade: 'Médio', tipo: 'Dissertativa', enunciado: 'Um terreno retangular tem 24 m de frente e 35 m de fundo. Calcule a área e o perímetro do terreno, registrando seu raciocínio.' },
      { serie: '9º ano', topico: 'Teorema de Pitágoras', dificuldade: 'Difícil', tipo: 'Múltipla escolha', enunciado: 'Uma escada de 5 m está apoiada em um muro, com a base afastada 3 m da parede. A que altura do chão a escada toca o muro?' },
      { serie: '6º ano', topico: 'Porcentagem', dificuldade: 'Fácil', tipo: 'V/F', enunciado: 'Uma camiseta de R$ 40 está com 25% de desconto. Afirmação: o preço final é R$ 30. Verdadeiro ou falso? Justifique com o cálculo.' },
      { serie: '9º ano', topico: 'Funções', dificuldade: 'Difícil', tipo: 'Dissertativa', enunciado: 'O lucro de uma lanchonete é dado por L(x) = 8x − 240, onde x é o número de lanches vendidos no dia. A partir de quantos lanches o dia deixa de ter prejuízo?' },
    ],
  },
  {
    disciplina: 'Língua Portuguesa',
    questions: [
      { serie: '6º ano', topico: 'Interpretação de texto', dificuldade: 'Fácil', tipo: 'Múltipla escolha', enunciado: "No trecho 'A chuva caía fina sobre a cidade adormecida', a palavra 'adormecida' sugere que a cidade estava em qual situação?" },
      { serie: '7º ano', topico: 'Classes de palavras', dificuldade: 'Médio', tipo: 'Dissertativa', enunciado: "Identifique os adjetivos em 'O velho casarão amarelo guardava histórias antigas' e explique o efeito de sentido que eles criam na descrição." },
      { serie: '8º ano', topico: 'Figuras de linguagem', dificuldade: 'Médio', tipo: 'Múltipla escolha', enunciado: "'O vento sussurrava segredos entre as árvores.' Que figura de linguagem o autor utilizou para dar vida ao vento?" },
      { serie: '9º ano', topico: 'Período composto', dificuldade: 'Difícil', tipo: 'Dissertativa', enunciado: "Reescreva o período 'Quando o sino tocou, todos saíram correndo' transformando a oração subordinada adverbial em sua forma reduzida." },
      { serie: '6º ano', topico: 'Gêneros textuais', dificuldade: 'Fácil', tipo: 'V/F', enunciado: 'Afirmação: uma receita de bolo é um texto injuntivo, pois orienta o leitor a executar uma tarefa passo a passo. Verdadeiro ou falso?' },
      { serie: '9º ano', topico: 'Variação linguística', dificuldade: 'Difícil', tipo: 'Dissertativa', enunciado: "Por que a frase 'Nóis foi no mercado' não é 'errada' do ponto de vista linguístico? Diferencie norma-padrão de variedade popular na resposta." },
    ],
  },
  {
    disciplina: 'Ciências',
    questions: [
      { serie: '6º ano', topico: 'Sistema Solar', dificuldade: 'Fácil', tipo: 'Múltipla escolha', enunciado: "Qual planeta do Sistema Solar é chamado de 'planeta vermelho' por causa do óxido de ferro presente em sua superfície?" },
      { serie: '7º ano', topico: 'Cadeias alimentares', dificuldade: 'Médio', tipo: 'Dissertativa', enunciado: 'Em uma lagoa, algas servem de alimento para peixes pequenos, que são caçados por garças. Monte a cadeia alimentar e identifique produtores e consumidores.' },
      { serie: '8º ano', topico: 'Sistema digestório', dificuldade: 'Médio', tipo: 'Múltipla escolha', enunciado: 'Durante a digestão, qual órgão é responsável pela maior parte da absorção dos nutrientes dos alimentos?' },
      { serie: '9º ano', topico: 'Matéria e substâncias', dificuldade: 'Difícil', tipo: 'Dissertativa', enunciado: 'O gás carbônico (CO₂) é formado por 1 átomo de carbono e 2 de oxigênio. Use esse exemplo para explicar a diferença entre átomo, molécula e substância.' },
      { serie: '7º ano', topico: 'Saúde e vacinação', dificuldade: 'Fácil', tipo: 'V/F', enunciado: 'Afirmação: as vacinas estimulam o corpo a produzir anticorpos antes do contato com o agente causador da doença. Verdadeiro ou falso?' },
      { serie: '9º ano', topico: 'Cinemática', dificuldade: 'Difícil', tipo: 'Múltipla escolha', enunciado: 'Um ciclista percorre 36 km em 2 horas mantendo ritmo constante. Qual é a sua velocidade média em metros por segundo?' },
    ],
  },
  {
    disciplina: 'História',
    questions: [
      { serie: '6º ano', topico: 'Egito Antigo', dificuldade: 'Fácil', tipo: 'Múltipla escolha', enunciado: 'As cheias anuais do rio Nilo eram celebradas pelos egípcios. Qual era a principal importância do rio para aquela civilização?' },
      { serie: '7º ano', topico: 'Brasil Colônia', dificuldade: 'Médio', tipo: 'Dissertativa', enunciado: 'Explique como funcionava o sistema de capitanias hereditárias e aponte dois motivos pelos quais a maioria delas fracassou.' },
      { serie: '8º ano', topico: 'Revolução Industrial', dificuldade: 'Médio', tipo: 'Múltipla escolha', enunciado: 'Qual foi a principal fonte de energia que movimentou as máquinas das primeiras fábricas durante a Revolução Industrial?' },
      { serie: '9º ano', topico: 'Era Vargas', dificuldade: 'Difícil', tipo: 'Dissertativa', enunciado: 'Compare o Estado Novo (1937-1945) com o período democrático anterior, citando duas mudanças políticas significativas trazidas pelo regime.' },
      { serie: '6º ano', topico: 'Povos originários', dificuldade: 'Fácil', tipo: 'V/F', enunciado: 'Afirmação: antes da chegada dos portugueses, o território brasileiro já era habitado por povos com línguas e culturas diversas. Verdadeiro ou falso?' },
      { serie: '9º ano', topico: 'Guerra Fria', dificuldade: 'Difícil', tipo: 'Múltipla escolha', enunciado: "O que caracterizou a 'corrida espacial' disputada entre Estados Unidos e União Soviética durante a Guerra Fria?" },
    ],
  },
  {
    disciplina: 'Geografia',
    questions: [
      { serie: '6º ano', topico: 'Cartografia', dificuldade: 'Fácil', tipo: 'Múltipla escolha', enunciado: 'Em um mapa com escala 1:100.000, a distância de 1 centímetro no papel representa quantos quilômetros no terreno?' },
      { serie: '7º ano', topico: 'Regiões do Brasil', dificuldade: 'Médio', tipo: 'Dissertativa', enunciado: 'Cite duas características naturais e duas econômicas que diferenciam a Região Norte da Região Sul do Brasil.' },
      { serie: '8º ano', topico: 'América do Sul', dificuldade: 'Médio', tipo: 'Múltipla escolha', enunciado: 'Qual cordilheira se estende por cerca de 8 mil km ao longo da costa oeste da América do Sul, atravessando sete países?' },
      { serie: '9º ano', topico: 'Globalização', dificuldade: 'Difícil', tipo: 'Dissertativa', enunciado: 'Explique como a globalização aproximou mercados e culturas e, ao mesmo tempo, aprofundou desigualdades entre países centrais e periféricos.' },
      { serie: '6º ano', topico: 'Clima e tempo', dificuldade: 'Fácil', tipo: 'V/F', enunciado: "Afirmação: 'clima' e 'tempo atmosférico' são sinônimos e podem ser usados sem distinção. Verdadeiro ou falso? Justifique." },
      { serie: '8º ano', topico: 'Demografia', dificuldade: 'Difícil', tipo: 'Múltipla escolha', enunciado: 'Uma pirâmide etária com base estreita e topo alargado indica qual tendência demográfica para a população de um país?' },
    ],
  },
  {
    disciplina: 'Inglês',
    questions: [
      { serie: '6º ano', topico: 'Simple Present', dificuldade: 'Fácil', tipo: 'Múltipla escolha', enunciado: "Choose the correct option: 'She ___ breakfast every morning at 7 a.m.' — eat / eats / eating" },
      { serie: '7º ano', topico: 'Simple Past', dificuldade: 'Médio', tipo: 'Múltipla escolha', enunciado: "Complete the sentence: 'Yesterday, they ___ to the beach and ___ volleyball with their friends.'" },
      { serie: '8º ano', topico: 'Reading comprehension', dificuldade: 'Médio', tipo: 'Dissertativa', enunciado: "Leia: 'Recycling reduces waste, saves energy and protects wildlife.' Explique, em português, a ideia principal da frase e o que justifica cada benefício." },
      { serie: '6º ano', topico: 'Greetings', dificuldade: 'Fácil', tipo: 'V/F', enunciado: "Statement: a expressão 'Good evening' é usada para cumprimentar alguém pela manhã. True or false?" },
      { serie: '9º ano', topico: 'Conditionals', dificuldade: 'Difícil', tipo: 'Múltipla escolha', enunciado: "Choose the correct option: 'If it rains tomorrow, we ___ the picnic.' — cancel / will cancel / would cancel" },
      { serie: '9º ano', topico: 'Passive voice', dificuldade: 'Difícil', tipo: 'Dissertativa', enunciado: "Compare as manchetes 'City opens new park' e 'New park is opened by city'. Qual está na voz passiva e que efeito essa escolha cria no texto jornalístico?" },
    ],
  },
]

const DIFFICULTY_STYLES: Record<PreviewQuestion['dificuldade'], string> = {
  Fácil: 'bg-moss-100 text-moss-700 dark:bg-moss-500/30 dark:text-moss-300',
  Médio: 'bg-ochre-100 text-ochre-700 dark:bg-ochre-500/30 dark:text-ochre-300',
  Difícil: 'bg-blood-100 text-blood-700 dark:bg-blood-500/30 dark:text-blood-300',
}

const BankPreviewSection: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const revealRef = useRevealOnScroll<HTMLDivElement>()
  const active = PREVIEW_BANK[activeIndex]

  return (
    <section
      id="preview-banco"
      className="py-20 bg-cream-100 dark:bg-ink-700"
      aria-labelledby="preview-banco-titulo"
    >
      <div ref={revealRef} className="container mx-auto px-4">
        <div data-reveal-item className="text-center mb-10 max-w-3xl mx-auto">
          <p className="flex items-center justify-center gap-3 font-mono text-caderno-xs uppercase tracking-widest text-ink-400 dark:text-ink-300 mb-4">
            <span className="text-terra-500">03</span>
            <span aria-hidden="true" className="w-8 h-px bg-cream-400 dark:bg-ink-500" />
            Dentro do banco
          </p>
          <h2
            id="preview-banco-titulo"
            className="text-3xl md:text-4xl font-display text-ink-900 dark:text-cream-50 mb-4"
          >
            Olhe <span className="italic font-normal text-terra-500">dentro</span> do banco.
          </h2>
          <p className="text-lg text-ink-500 dark:text-cream-300">
            Questões revisadas por professores e organizadas pela BNCC. Escolha uma disciplina e
            confira você mesmo.
          </p>
        </div>

        <div data-reveal-item className="reveal-delay-1 flex flex-wrap gap-2 justify-center mb-8">
          {PREVIEW_BANK.map((d, i) => {
            const isActive = i === activeIndex
            return (
              <button
                key={d.disciplina}
                aria-pressed={isActive}
                onClick={() => setActiveIndex(i)}
                className={[
                  'px-4 py-2 rounded-caderno-xs text-sm font-medium transition-colors',
                  'focus:outline-none focus:ring-2 focus:ring-terra-300',
                  isActive
                    ? 'bg-terra-500 text-cream-50'
                    : 'bg-cream-200 dark:bg-ink-900 text-ink-700 dark:text-cream-200 hover:bg-cream-300',
                ].join(' ')}
              >
                {d.disciplina}
              </button>
            )
          })}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto">
          {active.questions.map((q, i) => (
            <div
              key={`${active.disciplina}-${i}`}
              data-reveal-item
              style={{ '--reveal-delay': `${Math.min(i, 4) * 80}ms` } as React.CSSProperties}
              className="flex flex-col bg-surface dark:bg-ink-900 border border-cream-400 dark:border-ink-500 border-l-2 border-l-terra-500 rounded-caderno-sm p-4 shadow-caderno-sm hover:shadow-caderno-md transition-shadow"
            >
              <div className="flex items-center justify-between gap-2 mb-2">
                <span className="font-mono text-xs uppercase tracking-wider text-ink-400 dark:text-ink-300">
                  {q.serie} · {q.topico}
                </span>
                <span
                  className={`px-2 py-0.5 rounded-full font-mono text-caderno-xs ${DIFFICULTY_STYLES[q.dificuldade]}`}
                >
                  {q.dificuldade}
                </span>
              </div>
              <p className="text-sm text-ink-700 dark:text-cream-200 leading-relaxed line-clamp-4 flex-1">
                {q.enunciado}
              </p>
              <p className="font-mono text-caderno-xs uppercase tracking-wider text-terra-500 mt-3">
                {q.tipo}
              </p>
            </div>
          ))}
        </div>

        <div data-reveal-item className="reveal-delay-2 grid grid-cols-2 md:grid-cols-4 border-y border-cream-400 dark:border-ink-500 divide-x divide-cream-400 dark:divide-ink-500 bg-cream-50 dark:bg-ink-900 max-w-5xl mx-auto mt-12" id="banco-numeros">
          {[
            { value: '729', suffix: '+', label: 'subtópicos da BNCC' },
            { value: '170', suffix: '', label: 'tópicos organizados' },
            { value: '17', suffix: '', label: 'disciplinas cobertas' },
            { value: '15', suffix: '', label: 'séries · Fundamental ao Médio' },
          ].map((s) => (
            <div key={s.label} className="p-6 md:p-8 text-center">
              <p className="font-display text-4xl md:text-5xl text-ink-900 dark:text-cream-50">
                {s.value}
                {s.suffix && (
                  <span className="italic font-normal text-terra-500">{s.suffix}</span>
                )}
              </p>
              <p className="font-mono text-caderno-xs uppercase tracking-wider text-ink-500 dark:text-cream-300 mt-2">
                {s.label}
              </p>
            </div>
          ))}
        </div>

        <div data-reveal-item className="reveal-delay-3 text-center mt-10">
          <Link
            to="/register"
            className="inline-flex items-center px-6 py-3 bg-terra-500 hover:bg-terra-700 text-cream-50 rounded-caderno-xs font-semibold shadow-caderno-md transition-colors focus:outline-none focus:ring-2 focus:ring-terra-300"
          >
            Ver banco completo <ArrowRight className="ml-2 w-4 h-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  )
}

export default BankPreviewSection
